import { useHistory } from 'react-router-dom'

export const FILTER_VALUE_SHOW_MY_MATCHES = '2'

export const useNavigation = (selectedGameStorageFilter) => {
  const history = useHistory()

  const goToUrl = url => {
    history.push(url)
    localStorage.setItem('matchFilter', FILTER_VALUE_SHOW_MY_MATCHES)
    localStorage.setItem(
      'matchFilterGame',
      JSON.stringify(selectedGameStorageFilter)
    )
  }

  return {
    goToUrl,
  }
}
